import React, {useState} from "react"

export default function Mobile({json, dependencies, onChangeField})
{        
    const phone = []
    const zChar = [' ', '(', ')', '-', '.']
    const [maxlength, setMaxLenght] = useState(17)

    const removeprefix = (phone) =>
    {
        if(phone.startsWith('+1')) phone = phone.substring(2)  
        return phone
    }

    const validate = (object) =>
    {    
        let p = phone[0]    
        p = p.replace(/[^\d]*/gi, "")
    
        if(p.length < 3) 
        {
            object.value = removeprefix(p)
            return
        } 

        if(p.length === 3) 
        {
            let pp = p
            let d4 = p.indexOf('(')
            let d5 = p.indexOf(')')
            if (d4 === -1) pp = "(" + pp
            if (d5 === -1) pp = pp + ")"
            object.value = removeprefix(pp)
            return
        } 

        if(p.length > 3 && p.length < 7) 
        {
            p = "(" + p
            let l30 = p.length
            let p30 = p.substring(0, 4)
            p30 = p30 + ")"    
            let p31 = p.substring(4, l30)
            let pp = p30 + p31    
            object.value = removeprefix(pp)
            return    
        } 
        
        if (p.length >= 7) 
        {
            p = "(" + p
            let l30 = p.length
            let p30 = p.substring(0, 4)
            p30 = p30 + ") "    
            let p31 = p.substring(4, l30)
            let pp = p30 + p31    
            let l40 = pp.length;
            let p40 = pp.substring(0, 9)
            p40 = p40 + "-"    
            let p41 = pp.substring(9, l40)
            let ppp = p40 + p41    
            object.value = removeprefix(ppp.substring(0, maxlength))
            return
        }   
    }
    
    const parser = (sStr, sChar) =>
    {        
        const zChar = sChar.length === null ? new Array(sChar) : sChar
        let sNewStr = "" 
   
        for (let i = 0; i < zChar.length; i++) 
        {
            sNewStr = ""
    
            let iStart = 0
            let iEnd = sStr.indexOf(sChar[i])
    
            while (iEnd !== -1) 
            {
                sNewStr += sStr.substring(iStart, iEnd)
                iStart = iEnd + 1
                iEnd = sStr.indexOf(sChar[i], iStart)
            }
            
            sNewStr += sStr.substring(sStr.lastIndexOf(sChar[i]) + 1, sStr.length)    
            sStr = sNewStr
        }
    
        return sNewStr
    }

    const parsePhone = (object) =>
    {        
        phone[0] = parser(removeprefix(object.value), zChar)
    }
    
    const handleKeyUp = (event) =>
    {   
        setMaxLenght(17)         
        
        const e = event !== undefined ? event : window.event
        const keycode = e.which !== false ? e.which : e.keyCode
        const object = e.target      
        parsePhone(object)    
        validate(object)

        if(dependencies) dependencies(json.key, object.value)
        if(onChangeField) onChangeField(json.key, object.value)

        if(object.value === '') 
        {
            setMaxLenght(17)
            return
        }
        
        setMaxLenght(14)
    }    

    return (
        <div className={"json-input mobile field_"+json.key}>                        
            <div className="input-mobile">
                {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} /> }
                <input type="tel" className={'input_'+json.key} maxlength={maxlength} name={json.key} value={json.value} placeholder={json.placeholder || ''} onKeyUp={handleKeyUp} />
            </div>  
        </div>  
    ) 
}